import { render, staticRenderFns } from "./Shopee_confirm.vue?vue&type=template&id=8f0359e8&scoped=true&"
import script from "./Shopee_confirm.vue?vue&type=script&lang=js&"
export * from "./Shopee_confirm.vue?vue&type=script&lang=js&"
import style0 from "./Shopee_confirm.vue?vue&type=style&index=0&id=8f0359e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0359e8",
  null
  
)

export default component.exports